import { useCallback, useEffect, useState } from 'react';
import BannerSlide from './BannerSlide';
import './BannerCarousel.css';

function BannerCarousel({ banners, intervalMs = 4000 }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const total = banners.length;

  const goNext = useCallback(() => {
    if (total <= 0) return;
    setActiveIndex((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    if (total <= 1) return undefined;

    const timer = setInterval(goNext, intervalMs);
    return () => clearInterval(timer);
  }, [goNext, intervalMs, total]);

  if (total === 0) {
    return null;
  }

  return (
    <header className="banner-carousel" aria-label="Promotional banners">
      <div
        className="banner-carousel__track"
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {banners.map((banner) => (
          <BannerSlide
            key={banner.id}
            image={banner.image}
            imageAlt={banner.imageAlt}
          />
        ))}
      </div>
    </header>
  );
}

export default BannerCarousel;
